import * as types from './mutation_types'

export default {
  [types.SET_ACTIVE_ORDERS] (state, data) {
    console.log('SET_ACTIVE_ORDERS', data)
    state.activeOrders = data
    window.localStorage.setItem('activeOrders', JSON.stringify(data))
  },

  [types.ADD_NEW_ACTIVE_ORDER] (state, order) {
    if (state.activeOrders && !state.activeOrders.find(value => value.id_H === order.id_H)) {
      state.activeOrders.push(order)
      window.localStorage.setItem('activeOrders', JSON.stringify(state.activeOrders))
    }
  },

  [types.UPDATE_ACTIVE_ORDER] (state, order) {
    if (state.activeOrders) {
      const index = state.activeOrders.findIndex(value => value.id_H === order.id_H)
      if (index) {
        state.activeOrders[index] = order
      }
    }
  },

  [types.SET_DRAFT_ORDER_FLOW_ENABLED] (state, value) {
    state.isDraftOrderFlowEnabled = value
  },

  [types.SET_BMI_ORDER] (state, value) {
    state.isBmiOrder = value
  },

  [types.SET_PAYMENT_TYPES] (state, value) {
    state.paymentTypes = value
  },
}
